import React from "react";
import PropTypes from "prop-types";
import "./CustomButton.css";

const CustomButton = ({
  width = "100%",
  height = "50px",
  paddingVertical = 15,
  paddingHorizontal = 15,
  backgroundColor = "#006400",
  disabledBackgroundColor = "#7ca97c",
  borderRadius = 8,
  borderWidth = 0,
  borderColor = "transparent",
  elevation = 0,
  text,
  textColor = "white",
  fontSize = 16,
  fontWeight = "600",
  // fontFamily = "Outfit-Medium",
  fontFamily = "",
  textAlign = "center",
  isLoading = false,
  isDisabled = false,
  loadingColor = "white",
  onClick,
  className,
  leftIcon,
  rightIcon,
}) => {
  const buttonStyle = {
    width,
    height,
    paddingTop: paddingVertical,
    paddingBottom: paddingVertical,
    paddingLeft: paddingHorizontal,
    paddingRight: paddingHorizontal,
    backgroundColor: isDisabled ? disabledBackgroundColor : backgroundColor,
    borderRadius,
    borderWidth,
    borderColor,
    boxShadow: elevation
      ? `0 ${elevation}px ${elevation * 2}px rgba(0, 0, 0, 0.1)`
      : "none",
    opacity: isDisabled ? 0.6 : 1,
    minWidth: 100,
  };

  const textStyle = {
    color: textColor,
    fontSize,
    fontWeight,
    fontFamily,
    textAlign,
    // lineHeight: fontSize * 1.2,
  };

  return (
    <button
      className={`custom-button ${className || ""}`}
      style={buttonStyle}
      onClick={onClick}
      disabled={isDisabled || isLoading}
    >
      {isLoading ? (
        <div className="loading">
          <span className="button-text" style={textStyle}>
            {text}
          </span>
          <div
            className="spinner"
            style={{ borderTopColor: loadingColor }}
          ></div>
        </div>
      ) : (
        <>
          {leftIcon && <span className="icon left-icon">{leftIcon}</span>}
          <span className="button-text" style={textStyle}>
            {text}
          </span>
          {rightIcon && <span className="icon right-icon">{rightIcon}</span>}
        </>
      )}
    </button>
  );
};

export default CustomButton;
